<script setup>
import { Button } from '@aryeo/runway'
import { router } from '@inertiajs/vue3'
import { computed, ref } from 'vue'

import { usePermissions } from '@/Hooks/Company/usePermissions.js'
import { useTenant } from '@/Hooks/Shared/useTenant.js'

const props = defineProps({
  customerTeamId: String,
  iconName: {
    type: String,
    default: 'plus',
  },
  text: {
    type: String,
    default: 'Create Listing',
  },
})

const { hasPermission } = usePermissions()
const { tenant } = useTenant()

const isDisabled = ref(false)

const hasNewListingsExperience = computed(() => tenant.value.company.new_listings_experience)

const buttonText = computed(() => (hasNewListingsExperience.value ? props.text : 'Create Listing'))

const createListing = (event) => {
  isDisabled.value = true

  const createListingRoute = hasNewListingsExperience.value
    ? 'web.company.listings.create-new'
    : 'web.company.listings.create'

  router.visit(route(createListingRoute, { customer_team_id: props.customerTeamId }), {
    onSuccess: () => (isDisabled.value = false),
  })
}
</script>

<template>
  <Button
    v-if="hasPermission('listing_create')"
    type="button"
    :disabled="isDisabled"
    :text="buttonText"
    :iconName
    @click="createListing"
  />
</template>
